import React from "react";
import Sidebar from "../components/Sidebar"; // Import the Sidebar component
import { Outlet } from "react-router-dom";

const AdminDashboard = () => {
  // Sidebar items
  const items = [
    { name: "Dashboard", link: "/admin/dashboard", icon: "🏠" },
    { name: "User Management", link: "/admin/user-management", icon: "👤" },
    { name: "Reports", link: "/admin/reports", icon: "📊" },
    { name: "Settings", link: "/admin/settings", icon: "⚙️" },
  ];

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar items={items} />
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <h1>Admin Dashboard</h1>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
